import { render, staticRenderFns } from "./CustomHeZhuBodyDialog.vue?vue&type=template&id=8a9fe058&"
import script from "./CustomHeZhuBodyDialog.vue?vue&type=script&lang=js&"
export * from "./CustomHeZhuBodyDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports